'use client';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { BaseModal } from '../BaseModal/BaseModal';
import { BasePrimaryButton } from '../../Buttons/BasePrimaryButton/BasePrimaryButton';
import styles from './DataExportModal.module.css';

interface DataExportModalProps {
	isOpen: boolean;
	onClose: () => void;
	onConfirm: () => Promise<void>;
	isLoading?: boolean;
}

export const DataExportModal = ({
	isOpen,
	onClose,
	onConfirm,
	isLoading,
}: DataExportModalProps) => {
	return (
		<BaseModal
			isOpen={isOpen}
			onClose={onClose}
			title="Exportar Dados"
			isLoading={isLoading}
			actions={
				<>
					<button
						className={styles.cancelButton}
						onClick={onClose}
						disabled={isLoading}
						type="button"
					>
						Cancelar
					</button>
					<BasePrimaryButton
						onClick={onConfirm}
						disabled={isLoading}
						className={styles.confirmButton}
					>
						Solicitar Exportação
					</BasePrimaryButton>
				</>
			}
		>
			<div className={styles.content}>
				<div className={styles.infoBox}>
					<InfoOutlinedIcon className={styles.infoIcon} />
					<p className={styles.infoText}>
						Você receberá um e-mail com um link seguro para download dos seus dados.
					</p>
				</div>

				<div className={styles.details}>
					<h4 className={styles.detailsTitle}>Dados incluídos</h4>
					<ul className={styles.list}>
						<li>Informações pessoais e de contato</li>
						<li>Dados de endereço</li>
						<li>Histórico de atividades na plataforma</li>
						<li>Configurações e preferências</li>
						<li>Relatórios e análises geradas</li>
					</ul>
				</div>

				<p className={styles.note}>O processamento pode levar algumas horas.</p>
			</div>
		</BaseModal>
	);
};
